import { render } from "./Main.vue?vue&type=template&id=22cdeb88&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=22cdeb88&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-22cdeb88"

export default script